import axios from 'axios';

export const PERFORM_REQUEST = 'PERFORM_REQUEST';
export const PERFORM_REQUEST_PAST = 'PERFORM_REQUEST_PAST';
export const PERFORM_REQUEST_SUCCESS = 'PERFORM_REQUEST_SUCCESS';
export const PERFORM_REQUEST_FAILURE = 'PERFORM_REQUEST_FAILURE';
export const SET_PAGE = 'SET_PAGE';
export const INIT_CATEGORIES = 'INIT_CATEGORIES';
export const INIT_TRANSLATIONS = 'INIT_TRANSLATIONS';
export const SET_CATEGORY = 'SET_CATEGORY';
export const FIND_AND_SET_CATEGORY = 'FIND_AND_SET_CATEGORY';
export const INIT_LANGUAGE = 'INIT_LANGUAGE';
export const PROJECT_CLEAR_RESULTS = 'PROJECT_CLEAR_RESULTS';
export const PROJECT_SET_SELECTED_TAG = 'PROJECT_SET_SELECTED_TAG';
export const PROJECT_SET_SELECTED_THEME_TAG = 'PROJECT_SET_SELECTED_THEME_TAG';
export const PROJECT_FIND_AND_SET_SELECTED_TAG = 'PROJECT_FIND_AND_SET_SELECTED_TAG';
export const INIT_PAST = 'INIT_PAST';

export const ADD_CATEGORY_FILTER = 'ADD_CATEGORY_FILTER';
export const REMOVE_CATEGORY_FILTER = 'REMOVE_CATEGORY_FILTER';
export const REMOVE_MANY_FILTERS = "REMOVE_MANY_FILTERS";
export const SET_THEME_CATEGORY = 'SET_THEME_CATEGORY';
export const INIT_THEME_CATEGORIES = 'INIT_THEME_CATEGORIES'
export const PROJECT_REMOVE_SELECTED_THEME_TAG = 'PROJECT_REMOVE_SELECTED_THEME_TAG';
export const PROJECT_REMOVE_RESEARCHAREA_CATEGORIES = 'PROJECT_REMOVE_RESEARCHAREA_CATEGORIES';
export const PROJECT_REMOVE_THEME_CATEGORIES = 'PROJECT_REMOVE_THEME_CATEGORIES';

export function performRequest(params) {
  return (dispatch, getState) => {
    dispatch({ type: PERFORM_REQUEST });
    return axios
      .get(
        `/api/v1/projects/getprojects?lang=${getState().language}&page=${getState().page -
          1}&itemsperpage=10&active=${!params.past}&category=${getState().category},${getState().themeCategory}`
      )
      .then(response => {
        if (params.replace) {
          dispatch({
            type: PROJECT_CLEAR_RESULTS,
          });
        }
        dispatch({
          type: PERFORM_REQUEST_SUCCESS,
          data: response.data,
        });
      })
      .catch(error => {
        console.error('PERFORM_REQUEST_FAILURE', error);
        dispatch({ type: PERFORM_REQUEST_FAILURE });
      });
  };
}

export function setSearchQuery(query) {
  return {
    type: SET_SEARCH_QUERY,
    query,
  };
}

export function initPast(past) {
  return {
    type: INIT_PAST,
    past
  }
}

export function setPage(page) {
  return {
    type: SET_PAGE,
    page,
  };
}

export function setCategory(category) {
  return {
    type: SET_CATEGORY,
    category,
  };
}

export function findAndSetCategory(id) {
  return {
    type: FIND_AND_SET_CATEGORY,
    id,
  }
}

export function setThemeCategory(category) {
  return {
    type: SET_THEME_CATEGORY,
    category
  }
}

export function initCategories(categories) {
  return {
    type: INIT_CATEGORIES,
    categories,
  };
}

export function initTranslations(translations) {
  return {
    type: INIT_TRANSLATIONS,
    translations,
  };
}

export function initLanguage(language) {
  return {
    type: INIT_LANGUAGE,
    language,
  };
}

export function clearLatestResults() {
  return {
    type: PROJECT_CLEAR_RESULTS,
  };
}

export function setSelectedProjectTag(id) {
  return {
    type: PROJECT_SET_SELECTED_TAG,
    id,
  };
}

export function setSelectedProjectThemeTag(id) {
  return {
    type: PROJECT_SET_SELECTED_THEME_TAG,
    id,
  }
}

export function findAndSetSelectedProjectTag(id) {
  return {
    type: PROJECT_FIND_AND_SET_SELECTED_TAG,
    id,
  }
}

export function addCategoryFilter(category) {
    return {
        type: ADD_CATEGORY_FILTER,
        category
    }
}

export function removeCategoryFilter(category) {
    return {
        type: REMOVE_CATEGORY_FILTER,
        category,
    }
}

export function removeResearchAreaFilters() {
    return {
        type: REMOVE_MANY_FILTERS,
    }
}

export function initThemeCategories(themeCategories) {
    return {
        type: INIT_THEME_CATEGORIES,
        themeCategories,
    };
}

export function addSelectedThemeTag(id) {
    return {
        type: PROJECT_ADD_SELECTED_THEME_TAG,
        id,
    }
}

export function removeSelectedThemeTag(id) {
    return {
        type: PROJECT_REMOVE_SELECTED_THEME_TAG,
        id,
    }
}

export function removeResearchAreaCategories() {
    return {
        type: PROJECT_REMOVE_RESEARCHAREA_CATEGORIES,
    }
}

export function removeThemeCategories() {
    return {
        type: PROJECT_REMOVE_THEME_CATEGORIES,
    }
}